'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DrawerSort = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

var _listeners = require('../utils/listeners');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var DrawerSort = exports.DrawerSort = function () {
  function DrawerSort(_ref) {
    var el = _ref.el,
        context = _ref.context;
    (0, _classCallCheck3.default)(this, DrawerSort);

    this.el = el;
    this.context = context;

    this.setupListeners();

    this.selectedFilters = this.context.getElements(this.selectors.group).map(function (el) {
      return {
        el: el,
        title: el.dataset.drawerFiltersTitle,
        selected: ''
      };
    });
  }

  (0, _createClass3.default)(DrawerSort, [{
    key: 'setupListeners',
    value: function setupListeners() {
      this.listeners = new _listeners.Listeners();

      this.listeners.add(this.el, 'click', this.handleButtonClick.bind(this));
    }
  }, {
    key: 'handleButtonClick',
    value: function handleButtonClick(evt) {
      evt.preventDefault();
      if (!this.hasButton(evt.target)) return;

      this.getAllButtons().forEach(function (el) {
        el.setAttribute('aria-current', 'false');
      });

      evt.target.setAttribute('aria-current', 'true');

      var sort = evt.target.value;
      this.dispatchEvent(sort);

      this.closeDrawer();
    }
  }, {
    key: 'dispatchEvent',
    value: function dispatchEvent(sort) {
      this.el.dispatchEvent(new CustomEvent('filterChange', {
        detail: { sort: sort }
      }));
    }
  }, {
    key: 'closeDrawer',
    value: function closeDrawer() {
      window.drawers.activeDrawerKey = '';
    }
  }, {
    key: 'getButton',
    value: function getButton(el) {
      return el.closest(this.selectors.button);
    }
  }, {
    key: 'hasButton',
    value: function hasButton(el) {
      return this.getButton(el) != null;
    }
  }, {
    key: 'getAllButtons',
    value: function getAllButtons() {
      return (0, _functional.getElements)(this.selectors.button, { context: this.el });
    }
  }, {
    key: 'selectors',
    get: function get() {
      return {
        button: '.' + this.context.className + '_Button'
      };
    }
  }]);
  return DrawerSort;
}();